export default "__VITE_PUBLIC_ASSET__6bb3531c__"